import React, { useState } from 'react';

interface FormData {
  name: string;
  email: string;
  comments: string;
}

const Contact: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    comments: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const emailData = {
      to: 'brian@obermanfinancialcoach.com',
      subject: 'Contact Form Submission',
      text: `Name: ${formData.name}\nEmail: ${formData.email}\nComments: ${formData.comments}`
    };

    try {

      //console.log('NODE_ENV:', process.env.NODE_ENV);
      // console.log('Send email URL:', process.env.REACT_APP_SENDEMAIL_URL);

      const response = await fetch(`${process.env.REACT_APP_SENDEMAIL_URL}/send-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(emailData)
      });

      if (response.ok) {
        alert('Email sent successfully!');
      } else {
        alert('Failed to send email.');
      }
    } catch (err) {
      console.error('Error sending email:', err);
      alert('Error sending email.');
    }
  };

  return (
    <div className='Pages'>
      <form onSubmit={handleSubmit}>
        <label>
          Name
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />
        </label>
        <br />
        <label>
          Email
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />
        </label>
        <br />
        <label>
          Comments
          <textarea name="comments" value={formData.comments} onChange={handleChange} required />
        </label>
        <br />
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default Contact;
